// The signed-in NON-MEMBER predicate for a white-label host — the ONE
// definition, shared by the gate component (WhitelabelRequestAccess) and
// every shell surface that must stand down while the gate is up
// (CreditBlocker was the first: its "out of credits" overlay painted over
// the request-access card, measured on app.bellforge.eu 2026-08-31).
//
// Fail closed on every unknown, exactly as the component documents: no
// auth, no brand, no pin, or orgs not yet loaded all answer false.
import { isCustomDomainHost } from './customDomainHost.js'
import { getHostScopeOrgId } from './hostScopePin.js'

export const isWhitelabelNonMember = (root) => {
  if (!root || !root._authReady || !root.signedIn) return false
  if (!root.whitelabelBrand) return false
  // The root MIRROR first (customDomainBoot writes it the moment the scope
  // lands, and subscribeTo re-fires on it); the module pin stays as the
  // fallback for any boot that predates the mirror.
  const pin = root._hostScopeOrgId || getHostScopeOrgId()
  if (!pin) return false
  const orgs = Array.isArray(root.orgs) ? root.orgs : null
  if (!orgs) return false
  return !orgs.some((o) => o && String(o.id || o._id) === pin)
}

// The el.call face: host check + membership in one verdict, so a caller
// needs no second import to know "is the request-access gate what this
// visitor is looking at right now".
export const isWhitelabelNonMemberGateActive = function (root) {
  return isCustomDomainHost() && isWhitelabelNonMember(root)
}
